<template lang="pug">
#vcard-generator
  v-btn(
    plain,
    x-small,
    @click='downloadVCard()',
    prepend-icon="mdi-account-box-outline",
    variant="plain" 
  ) VCard

  person-qr-code(:text='generateVCard()')
</template>

<script setup lang="ts">
defineOptions({
  name: 'VCardGenerator',
})

const props = defineProps({
  familyName: {
    type: String,
    default: '',
  },
  givenName: {
    type: String,
    default: '',
  },
  prefix: {
    type: String,
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
  formattedName: {
    type: String,
    default: '',
  },
  nickname: {
    type: String,
    default: '',
  },
  extraNameMaidenName: {
    type: String,
    default: '',
  },
  extraNamePhoneticFirstName: {
    type: String,
    default: '',
  },
  extraNamePhoneticMiddleName: {
    type: String,
    default: '',
  },
  extraNamePhoneticLastName: {
    type: String,
    default: '',
  },
  extraNamePronunciationFirstName: {
    type: String,
    default: '',
  },
  extraNamePronunciationMiddleName: {
    type: String,
    default: '',
  },
  extraNamePronunciationLastName: {
    type: String,
    default: '',
  },
  workTitle: {
    type: String,
    default: '',
  },
  workRole: {
    type: String,
    default: '',
  },
  email: {
    type: String,
    default: '',
  },
  phone: {
    type: String,
    default: '',
  },
  addressStreet: {
    type: String,
    default: '',
  },
  addressLocality: {
    type: String,
    default: '',
  },
  addressRegion: {
    type: String,
    default: '',
  },
  addressPostalcode: {
    type: String,
    default: '',
  },
  socialProfiles: {
    type: Array,
    default: () => [],
  },
  website: {
    type: String,
    default: '',
  },
  photo: {
    type: String,
    default: '',
  },
  birthDayYear: {
    type: Number,
    default: null,
  },
  birtdayMonth: {
    type: Number,
    default: null,
  },
  birthDayDay: {
    type: Number,
    default: null,
  },
  gender: {
    type: String,
    default: '',
  },
  notes: {
    type: Array,
    default: () => [],
  },
})

// generate the vcard string manually
function generateVCard(): string {
  const notes = props.notes as Array<string>

  return [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `N:${props.familyName};${props.givenName};;;`,
    `FN:${props.formattedName || `${props.givenName} ${props.familyName}`}`,
    props.nickname ? `NICKNAME:${props.nickname}` : '',
    props.workTitle ? `TITLE:${props.workTitle}` : '',
    props.workRole ? `ROLE:${props.workRole}` : '',
    props.email ? `EMAIL;TYPE=work:${props.email}` : '',
    props.phone ? `TEL;TYPE=work:${props.phone}` : '',
    props.website ? `URL:${props.website}` : '',
    props.photo ? `PHOTO;VALUE=uri:${props.photo}` : '',
    props.birthDayYear
      ? `BDAY:${props.birthDayYear}-${String(props.birtdayMonth).padStart(2, '0')}-${String(props.birthDayDay).padStart(2, '0')}`
      : '',
    props.gender ? `GENDER:${props.gender}` : '',
    props.addressStreet || props.addressLocality
      ? `ADR;TYPE=work:;;${props.addressStreet};${props.addressLocality};${props.addressRegion};${props.addressPostalcode};Germany`
      : '',
    ...notes.map((note) => `NOTE:${note}`),
    'END:VCARD',
  ]
    .filter(Boolean)
    .join('\n')
}

function downloadVCard() {
  const blob = new Blob([generateVCard()], { type: 'text/vcard;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'contact.vcf'
  a.click()
  URL.revokeObjectURL(url)
}
</script>
